module.exports = __webpack_public_path__ + "static/fonts/Mont-Light.446a23f.eot";